import React from 'react';
import { Spinner, View, Text } from '@instructure/ui';
const FragmentLoader = (props) => {
  return (
    <View as="div">
      <Spinner
        size={props?.spinnerSize || 'x-small'}
        renderTitle={props?.title || 'Loading'}
        margin={props?.spinnerMargin || 'none x-small none none'}
      />
      <Text
        variant={props?.textVariant || 'contentSmall'}
        margin={props?.textMargin || 'none'}
      >
        {props?.title || 'Loading'}
      </Text>
    </View>
  );
};

export default FragmentLoader;
